/* eslint-disable */
// @ts-nocheck

import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { SelectInterface } from '../../interfaces/InterfacesLocal'

interface ScrollTypeFilterProp {
  title: string
  items: SelectInterface[]
  onChange: Function
  current: string | number | boolean | string | null
  allButtonDisabled?: boolean
  scrollbarDisabled?: boolean
  allButtonEnd?: boolean
  className?: string
}

const ScrollTypeFilter = ({
  title,
  items,
  current,
  onChange,
  allButtonDisabled,
  scrollbarDisabled = true,
  allButtonEnd,
  className,
}: ScrollTypeFilterProp) => {
  const slideLeft = () => {
    const slider = document.getElementById('slider-' + title)
    if (slider !== null) slider.scrollLeft -= 500
  }

  const slideRight = () => {
    const slider = document.getElementById('slider-' + title)
    if (slider !== null) slider.scrollLeft += 500
  }
  return (
    <div className={`${className ? className : 'my-6'}`}>
      <h4 className="mt-5 pl-5 text-lg font-medium text-gray-900">{title}</h4>
      <div className="relative flex items-center">
        <FontAwesomeIcon
          className="cursor-pointer opacity-50 hover:opacity-100"
          icon={faChevronLeft}
          onClick={slideLeft}
          size={'lg'}
        />
        <div
          className={`flex h-full w-full overflow-x-scroll whitespace-nowrap pb-4 pt-2 align-middle scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-slate-600 ${
            scrollbarDisabled ? `scrollbar-none` : ''
          }`}
          id={`slider-${title}`}
        >
          {!allButtonDisabled && (
            <button
              className={`m-1 flex cursor-pointer items-center rounded-full border-2 px-5 py-1 duration-300 ease-in-out hover:scale-105 ${
                current !== null
                  ? 'border-gray-300'
                  : 'border-gray-900 bg-gray-600 text-white'
              }`}
              onClick={() => {
                onChange(null)
              }}
              type="button"
            >
              Todos
            </button>
          )}

          {items.map((item, index) => (
            <button
              className={`m-1 flex cursor-pointer items-center rounded-full border-2 px-5 py-1 duration-300 ease-in-out hover:scale-105 ${
                current !== item.id
                  ? 'border-gray-300'
                  : 'border-gray-900 bg-gray-600 text-white'
              }`}
              key={index}
              onClick={() => {
                onChange(item.id)
              }}
              type="button"
            >
              {item.name}
            </button>
          ))}

          {allButtonEnd && (
            <button
              className={`m-1 flex cursor-pointer items-center rounded-full border-2 px-5 py-1 duration-300 ease-in-out hover:scale-105 ${
                current !== null
                  ? 'border-gray-300'
                  : 'border-gray-900 bg-gray-600 text-white'
              }`}
              onClick={() => {
                onChange(null)
              }}
              type="button"
            >
              Todos
            </button>
          )}
        </div>
        <FontAwesomeIcon
          className="cursor-pointer opacity-50 hover:opacity-100"
          icon={faChevronRight}
          onClick={slideRight}
          size={'lg'}
        />
      </div>
    </div>
  )
}

export default ScrollTypeFilter
